module.exports = __webpack_public_path__ + "static/media/1_4.27edaa10.png";